import { compareVersions } from "compare-versions";
import { useMemo } from "react";
import type { AppTypeEnum } from "../../apiTypes";
import { isAndroid, isIOS, isWeb } from "../constants";
import { useGetCurrentAppVersionQuery } from "../queries/Token.generated";

export function useNeedToUpgradeApp({
  version,
  appType,
}: { version: string | null; appType: AppTypeEnum }) {
  const { data: appVersions } = useGetCurrentAppVersionQuery({ variables: { appType } });

  const needToUpgradeVersion = useMemo(() => {
    if (isWeb || !appVersions) return false;

    const iosUpgrade =
      isIOS && version ? compareVersions(version, appVersions?.getCurrentAppVersion.iosVersion) : 1;

    const androidUpgrade =
      isAndroid && version
        ? compareVersions(version, appVersions?.getCurrentAppVersion.androidVersion)
        : 1;

    return iosUpgrade === -1 || androidUpgrade === -1;
  }, [appVersions, version]);

  return needToUpgradeVersion;
}
